/****************************************************
 * Module Name:  reviseAverage.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import Constants from "../../utility/constants";
import React, { useEffect } from "react";
import { useState } from "react";
import { alpha, Badge, Box, Button, CircularProgress, Menu, MenuItem, styled, Tooltip, Typography, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { BackupTable } from "@mui/icons-material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import renderCellExpand from "../common/dataGridCellExpand";
import Papa from 'papaparse';
import ReviseProxy from "../../utility/proxy/manager/reviseProxy";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import Utility from "../../utility/utility";
import EditIcon from '@mui/icons-material/Edit';
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import StoneDetailModal from "../common/stoneDetailModal";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import colourchart from '../../images/ColorScheme.png'
import CommonStoneSelection from "../common/commonStoneSelection";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";
import PacketHistoryModal from "../common/packetHistoryModal";
import PageTitle from "../common/pageTitle";

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    "& .super-app-theme--NEW": {
        backgroundColor: "#F9F08D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F9F08D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    '& .MuiDataGrid-columnHeader': {
        color: '#fff',
        backgroundColor: 'grey',
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },
    "& .super-app-theme--LAB": {
        backgroundColor: "#7EAEEE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#7EAEEE",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
            color: "black",
        },
    },
    "& .super-app-theme--RE-LAB": {
        backgroundColor: "#FCCD91",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FCCD91",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK": {
        backgroundColor: "#FFFFCC",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FFFFCC",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_SENT": {
        backgroundColor: "#B8ACF6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B8ACF6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_DONE": {
        backgroundColor: "#388BFF",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#388BFF",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MIX": {
        backgroundColor: "#E0E88C",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#E0E88C",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE_APPROVAL_PENDING": {
        backgroundColor: "#FBDEDE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FBDEDE",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE": {
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--HOLD": {
        backgroundColor: "#B6B9D6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B6B9D6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MEMO_OUT": {
        backgroundColor: "#CAF7F6",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#CAF7F6",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL": {
        backgroundColor: "#CCFF99",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#CCFF99",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL_SENT": {
        backgroundColor: "#F797D2",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F797D2",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SOLD": {
        backgroundColor: "#26D4B9",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#26D4B9",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL_CANCELLED": {
        backgroundColor: "#F59598",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F59598",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--LOCATION_SENT": {
        backgroundColor: "#FEBD7D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FEBD7D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },

}));

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));

const ReviseAverage = () => {
    const { apiRef, handleCellClick } = Utility.useSingleClickEdit();
    const [showError, setShowError] = useState(false);
    const [uploadSuccessSnackbar, setUploadSuccessSnackbar] = useState(false);
    const [ApplySuccessSnackbar, setApplySuccessSnackbar] = useState(false);
    const [uploadResponse, setUploadResponse] = useState("");
    const [uploadLoader, setUploadLoader] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [columnNames, setColumnNames] = React.useState([]);
    const [stockLoader, setStockLoader] = useState(false);
    const [applyLoader, setApplyLoader] = useState(false);
    const [stoneId, setStoneId] = useState("");
    const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
    const [kapanId, setKapanId] = useState("");
    const [showKapanDetailModal, setShowKapanDetailModal] = useState(false);
    const [packetId, setPacketId] = useState("");
    const [showPacketDetailModal, setShowPacketDetailModal] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [applyButtonDisabled, setApplyButtonDisabled] = useState(true);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState("");

    //top most summary table 
    const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
    const [selectedTotalSize, setSelectedTotalSize] = useState("0");
    const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
    const [selectedavgPrice, setSelectedavgPrice] = useState("0");
    const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");
    const [selectedTotalOfAvgPrice, setSelectedTotalOfAvgPrice] = useState("0");
    const [selectedAvgOfAvgPrice, setSelectedAvgOfAvgPrice] = useState("0");
    const [selectedAvgOfAvgDiscount, setSelectedAvgOfAvgDiscount] = useState("0");

    const [selectedNewTotalOfAvgPrice, setSelectedNewTotalOfAvgPrice] = useState("0");
    const [selectedNewAvgOfAvgPrice, setSelectedNewAvgOfAvgPrice] = useState("0");
    const [selectedNewAvgOfAvgDiscount, setSelectedNewAvgOfAvgDiscount] = useState("0");

    const [showUploadedAvgSummary, setShowUploadedAvgSummary] = useState(false);

    // Color Scheme Drop Down Button
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseButton = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        PageTitle("OPERATION_REVISE_AVERAGE");
        handleSearch();
    }, []);

    const loadTotalData = (data) => {
        let totalSize = 0;
        let totalPrice = 0;   //ppc*size
        let total = 0;       //rapnetprice*size
        let totalAvgPrice = 0;
        let avgTotal = 0;

        data.forEach((iData) => {
            let pricePerCarat = iData.price
            totalSize += iData.size;
            totalPrice += (iData.size * pricePerCarat);
            total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
            totalAvgPrice += (iData.size * iData.avgprice);
            avgTotal += (iData.size * ((100 * iData.avgprice) / (100 + iData.avgdiscount)));
        });
        setNoOfSelectedStones(data.length);
        setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
        setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
        setSelectedavgPrice(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    totalPrice / totalSize
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
        setSelectedAvgDiscount(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    (100 - (totalPrice / total) * 100) * -1
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
        setSelectedTotalOfAvgPrice(Utility.ConvertNumberWithSpecifiedDigits(totalAvgPrice));
        setSelectedAvgOfAvgPrice(totalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits(totalAvgPrice / totalSize) : 0);
        setSelectedAvgOfAvgDiscount(totalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits((100 - (totalAvgPrice / avgTotal) * 100) * -1) : 0);
    };

    useEffect(() => {
        if (selectionModel.length <= 0) {
            loadTotalData(stockData);
            return;
        }
        let totalSize = 0;
        let totalPrice = 0;   //ppc*size
        let total = 0;       //rapnetprice*size
        let totalAvgPrice = 0;
        let avgTotal = 0;
        let newTotalAvgPrice = 0;
        let newAvgTotal = 0;

        stockData.forEach((iData) => {
            if (selectionModel.includes(iData.stoneid)) {
                let pricePerCarat = iData.price
                totalSize += iData.size;
                totalPrice += (iData.size * pricePerCarat);
                total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
                totalAvgPrice += (iData.size * iData.avgprice);
                avgTotal += (iData.size * ((100 * iData.avgprice) / (100 + iData.avgdiscount)));
                newTotalAvgPrice += (iData.size * iData.newavgprice);
                newAvgTotal += (iData.size * ((100 * iData.newavgprice) / (100 + iData.newavgdiscount)));
            }
        });

        setNoOfSelectedStones(selectionModel.length);
        setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
        setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
        setSelectedavgPrice(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    totalPrice / totalSize
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
        setSelectedAvgDiscount(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    (100 - (totalPrice / total) * 100) * -1
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
        setSelectedTotalOfAvgPrice(Utility.ConvertNumberWithSpecifiedDigits(totalAvgPrice));
        setSelectedAvgOfAvgPrice(totalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits(totalAvgPrice / totalSize) : 0);
        setSelectedAvgOfAvgDiscount(totalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits((100 - (totalAvgPrice / avgTotal) * 100) * -1) : 0);
        setSelectedNewTotalOfAvgPrice(Utility.ConvertNumberWithSpecifiedDigits(newTotalAvgPrice));
        setSelectedNewAvgOfAvgPrice(newTotalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits(newTotalAvgPrice / totalSize) : 0);
        setSelectedNewAvgOfAvgDiscount(newTotalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits((100 - (newTotalAvgPrice / newAvgTotal) * 100) * -1) : 0);
    }, [selectionModel]);

    const handleSearch = () => {
        //need all stones of every status
        let status = [];
        let newListData = [];
        setStockLoader(true);
        StoneProxy.GetStoneByStatus(
            status, (responseData) => {
                if (responseData) {
                    const distinctStatus = Utility.getDistinctOptions(responseData, 'status');
                    prepareColumns(distinctStatus);
                    responseData.map((iRes) => {
                        let listOp = {
                            ...iRes,
                            newavgprice: 0.00,
                            newavgdiscount: 0.00,
                            newavgtotal: 0.00,
                        }
                        newListData.push(listOp);
                        return true;
                    })
                    setStockData(newListData);
                    loadTotalData(newListData);
                    setStockLoader(false);
                } else {
                    setShowError(true);
                    setStockLoader(false);
                }
            });
    };

    const handleClose = () => {
        setShowStoneDetailModal(false);
        setUploadSuccessSnackbar(false);
        setApplySuccessSnackbar(false)
    };

    const handleClear = () => {
        const fileInput = document.getElementById('file-input');
        fileInput.value = null;
    }

    const handleStoneDetailModal = (params) => {
        setStoneId(params.value);
        setShowStoneDetailModal(true);
    };

    const handleProcessRowUpdateError = (error) => {
        // console.error(error);
    };



    const processRowUpdate = (newRow, oldRow) => {
        const changedFeilds = Utility.getChangedFields(newRow, oldRow);
        if (changedFeilds.length > 0) {
            const { id, field, value } = changedFeilds[0];
            const updatedListData = stockData.map(row => {

                if (row.stoneid === id && (value !== undefined || value !== null)) {
                    let newRow = { ...row };
                    if (field === "newavgdiscount" && row.colortype === "WHITE") {
                        let ppc = Number(
                            (row.avgrapnetprice * ((1 + (Number(value)) / 100))).toFixed(2));
                        newRow = {
                            ...row,
                            [field]: Number(value),
                            newavgprice: ppc,
                            newavgtotal: Number((ppc * row.size).toFixed(2)),
                        };
                    }
                    else if (field === "newavgprice" && parseFloat(value) !== parseFloat(row.newavgprice)) {
                        let tdiscount = Number(((((row.avgrapnetprice - (Number(value))) / row.avgrapnetprice) * 100) * (-1)).toFixed(2));
                        newRow = {
                            ...row,
                            [field]: Number(value),
                            newavgdiscount: row.colortype === "WHITE" ? tdiscount : 0.00,
                            newavgtotal: parseFloat((Number(value) * row.size).toFixed(2)),
                        };
                    }
                    return newRow;
                }
                return row;
            });

            setStockData(updatedListData);

            let totalSize = 0;
            let totalAvgPrice = 0;
            let avgTotal = 0;

            updatedListData.forEach(iRow => {
                if (selectionModel.includes(iRow.stoneid)) {
                    totalSize += iRow.size;
                    totalAvgPrice += (iRow.size * iRow.newavgprice);
                    avgTotal += (iRow.size * ((100 * iRow.newavgprice) / (100 + iRow.newavgdiscount)));
                }
            })

            setSelectedNewTotalOfAvgPrice(Utility.ConvertNumberWithSpecifiedDigits(totalAvgPrice));
            setSelectedNewAvgOfAvgPrice(totalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits(totalAvgPrice / totalSize) : 0);
            setSelectedNewAvgOfAvgDiscount(totalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits((100 - (totalAvgPrice / avgTotal) * 100) * -1) : 0);
            setApplyButtonDisabled(false);

            const updatedRow = updatedListData.find(row => row.stoneid === id);
            return updatedRow;
        } else {
            // No changes detected, return the newRow to trigger exit edit mode
            return { ...newRow };
        }
    }

    const prepareColumns = (distinctStatus) => {
        let columnNames = [];

        Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
            if (columnsData.hasOwnProperty(iColPermission)) {
                const columnData = columnsData[iColPermission];
                if (columnData.field === "status") {
                    columnData.type = "singleSelect";
                    columnData.valueOptions = distinctStatus;
                    columnData.filterOperators = Utility.combinedFilters();
                }
                columnNames.push(columnData);
                if (columnData.field === "avgdiscount") {
                    columnNames.push(
                        {
                            field: "newavgdiscount",
                            headerName: "NEW AVG DIS",
                            headerAlign: "center",
                            align: "center",
                            width: 110,
                            editable: true,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{Utility.ConvertNumberWithSpecifiedDigits(params.row.newavgdiscount)}</span>
                                    {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: -16 }} />}
                                </div>
                            ),
                            cellClassName: (params) => 'lavenderCell',
                        }
                    )
                }
                else if (columnData.field === "avgprice") {
                    columnNames.push(
                        {
                            field: "newavgprice",
                            headerName: "NEW AVG PPC",
                            headerAlign: "center",
                            align: "center",
                            width: 120,
                            editable: true,
                            renderCell: (params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.newavgprice))}</span>
                                    <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: -16 }} />
                                </div>
                            ),
                            cellClassName: (params) => 'lavenderCell',
                        }
                    )
                }
                else if (columnData.field === "avgtotal") {
                    columnNames.push({
                        field: "newavgtotal",
                        headerName: "NEW AVG TOTAL",
                        headerAlign: "center",
                        align: "center",
                        width: 120,
                        renderCell: (params) => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ marginRight: '10px' }}>{Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.newavgtotal))}</span>
                            </div>
                        ),
                        editable: false,
                        cellClassName: (params) => 'lavenderCell',
                    })
                }
            }
        });
        setColumnNames(columnNames);
    }

    const handleUpload = (file) => {
        const reader = new FileReader();
        setUploadLoader(true);

        reader.onload = () => {
            const text = reader.result;
            Papa.parse(text, {
                header: true,
                skipEmptyLines: true,
                complete: (result) => {
                    const headersFromCSV = Object.keys(result.data[0]).filter(key => key !== "" && key !== "_1");
                    const columnFields = columnNames.map(column => column.field);
                    const matchingColumns = headersFromCSV.filter(header => columnFields.includes(header));

                    if (matchingColumns.length === headersFromCSV.length) {

                        let matchedList = [];
                        let unmatchedList = [];
                        const stoneIdsInStockData = new Set();

                        if (headersFromCSV.includes("avgdiscount")) {

                            result.data.map((record) => {
                                const matchedRecord = stockData.find(iRow => (Number(record.stoneid) === iRow.stoneid && iRow.colortype === "WHITE"));
                                if (matchedRecord && record.avgdiscount !== "") {
                                    let discount = Number(record.avgdiscount);
                                    let ppc = Number(
                                        (matchedRecord.avgrapnetprice * ((1 + (Number(discount)) / 100))).toFixed(2));
                                    let listOp = {
                                        ...matchedRecord,
                                        newavgdiscount: discount,
                                        newavgprice: ppc,
                                        newavgtotal: Number((ppc * matchedRecord.size).toFixed(2)),
                                    }
                                    matchedList.push(listOp);
                                    stoneIdsInStockData.add(matchedRecord.stoneid);
                                }
                                return true;
                            })
                        } else if (headersFromCSV.includes("avgprice")) {

                            result.data.map((record) => {
                                const matchedRecord = stockData.find(iRow => Number(record.stoneid) === iRow.stoneid);
                                if (matchedRecord && record.avgprice !== "") {
                                    let ppc = Number(record.avgprice);
                                    let discount = Number(((((matchedRecord.avgrapnetprice - ppc) / matchedRecord.avgrapnetprice) * 100) * (-1)).toFixed(2));
                                    let listOp = {
                                        ...matchedRecord,
                                        newavgdiscount: matchedRecord.colortype === "WHITE" ? discount : 0.00,
                                        newavgprice: ppc,
                                        newavgtotal: parseFloat(Number((ppc * matchedRecord.size).toFixed(2))),
                                    }
                                    matchedList.push(listOp);
                                    stoneIdsInStockData.add(matchedRecord.stoneid);
                                }
                                return true;
                            })
                        }

                        let totalSize = 0;
                        let totalAvgPrice = 0;
                        let avgTotal = 0;

                        matchedList.forEach(iRow => {
                            totalSize += iRow.size;
                            totalAvgPrice += (iRow.size * iRow.newavgprice);
                            avgTotal += (iRow.size * ((100 * iRow.newavgprice) / (100 + iRow.newavgdiscount)));
                        });

                        //to add unmatched stones down in the selection model
                        stockData.forEach(iRow => {
                            if (!stoneIdsInStockData.has(iRow.stoneid)) {
                                unmatchedList.push(iRow);
                            }
                        });

                        setSelectedNewTotalOfAvgPrice(Utility.ConvertNumberWithSpecifiedDigits(totalAvgPrice));
                        setSelectedNewAvgOfAvgPrice(totalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits(totalAvgPrice / totalSize) : 0);
                        setSelectedNewAvgOfAvgDiscount(totalAvgPrice > 0 ? Utility.ConvertNumberWithSpecifiedDigits((100 - (totalAvgPrice / avgTotal) * 100) * -1) : 0);

                        setSelectionModel(Array.from(stoneIdsInStockData));
                        setStockData(matchedList.concat(unmatchedList))
                        setUploadLoader(false);
                        setUploadSuccessSnackbar(true);
                        setApplyButtonDisabled(false);
                        setShowUploadedAvgSummary(true);
                    } else {
                        console.error('CSV columns do not match table columns.');
                        setUploadLoader(false);
                        setUploadSuccessSnackbar(true);
                    }
                },
                error: (error) => {
                    console.error('Error parsing CSV:', error);
                    setShowError(false);
                    setUploadLoader(false);
                }
            });
        };

        reader.readAsText(file);
    };

    const handleApply = () => {
        let data = [];
        let invalidDataStoneIds = [];
        setApplyLoader(true);

        selectionModel.map((id) => {
            const matchedRow = stockData.find(data => data.stoneid === id)
            if (matchedRow) {
                if ((matchedRow.newavgdiscount > -100 && matchedRow.newavgdiscount < 1000) &&
                    (matchedRow.newavgprice > 0) && (matchedRow.newavgtotal > 0)) {
                    data.push({
                        stoneid: parseInt(matchedRow.stoneid),
                        avgprice: matchedRow.newavgprice,
                        avgdiscount: matchedRow.newavgdiscount,
                    })
                } else {
                    invalidDataStoneIds.push(id);
                }
            }
            return true;
        })
        if (invalidDataStoneIds.length > 0) {
            setApplyLoader(false);
            setSnackBarMessage("Stone ids " + invalidDataStoneIds.join(",") + " have invalid data." +
                "Either correct the data or uncheck the stones to proceed");
            setShowSnackbar(true);
        }
        if (invalidDataStoneIds.length === 0) {
            ReviseProxy.SendReviseAverage(data, (response) => {
                if (response) {
                    setApplySuccessSnackbar(true);
                    setUploadResponse(response);
                    setApplyButtonDisabled(true);
                    setShowUploadedAvgSummary(false);
                    handleSearch();
                    setApplyLoader(false);
                    setSelectionModel([]);
                }
            });
        }

    };

    const handleSelection = (data) => {
        const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, stockData, selectionModel);

        setStockData(tempStockData);
        setSelectionModel(tempSelectionModel);
    }

    const columns = columnNames;
    const rows = stockData;
    const columnsData = {
        "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
            field: "stoneid",
            headerName: "STONEID",
            pinning: { position: 'left' },
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "number",
            valueFormatter: (params) => params.value,
            cellClassName: 'stickyColumn',
            renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handleStoneDetailModal(params)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },
        "9dfe5dd6-726c-465b-9f61-22fca6660b4f": {
            field: "kapanid",
            headerName: "KAPANID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => {
                        setKapanId(params.row.kapanid);
                        setShowKapanDetailModal(true);
                    }}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
            width: 80,
        },
        "8a492e00-6167-45de-b078-e572e47c8a39": {
            field: "packetid",
            headerName: "PACKETID",
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (Utility.NeedToShowPacketDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => {
                        setKapanId(params.row.kapanid)
                        setPacketId(params.row.packetid)
                        setShowPacketDetailModal(true)
                    }}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
            width: 80,
        },
        "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
            field: "status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
            cellClassName: (params) => `super-app-theme--${params.row.status.toUpperCase()}`,
        },
        "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
            field: "stonetype",
            headerName: "STONETYPE",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.value],
            renderCell: (params) => Constants.STONE_TYPE[params.value],
        },
        "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
            field: "shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            width: 40,
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
        },
        "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 65,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            width: 75,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "3597803f-8932-40c6-8de6-81006f4d6d5b": {
            field: "cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
            field: "pol",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "5541c182-21b8-496e-b342-b0b89f3d302f": {
            field: "sym",
            headerName: "SYM",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "8296e627-0be5-4a66-830f-ea6867cea137": {
            field: "flo",
            headerName: "FLO",
            headerAlign: "center",
            align: "center",
            width: 60,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "798a8663-0f0c-41be-8512-16dd60d5f25e": {
            field: "discount",
            headerName: "DIS",
            headerAlign: "center",
            align: "right",
            width: 50,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)
        },
        "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
            field: "rapnetprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "right",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
        },
        "39c634f1-2644-4307-acbb-983b4de4229e": {
            field: "price",
            headerName: "PPC",
            headerAlign: "center",
            align: "right",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
        },
        "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
            field: "total",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "right",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
        },
        "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
            field: "measurements",
            headerName: "MEASUREMENTS",
            headerAlign: "center",
            align: "center",
            width: 140,
            renderCell: renderCellExpand,
        },
        "567202e6-c31c-4c19-9998-1cacae05af6e": {
            field: "depth",
            headerName: "DEPTH",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
            field: "lab",
            headerName: "LAB",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "7e356515-7cc5-4cd4-a1a4-a1b909b3b4e3": {
            field: "avgrapnetprice",
            headerName: "AVG RAP PRICE",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.avgrapnetprice)
        },
        "a330b2b8-b9e4-40bb-bb7a-d0e83a717a74": {
            field: "avgdiscount",
            headerName: "AVG DIS",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 90,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.avgdiscount)
        },
        "1ac589a9-ff76-4b9a-9b6e-f0d7951dc0ca": {
            field: "avgprice",
            headerName: "AVG PRICE",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.avgprice),
        },
        "49b8f961-fe52-48ca-afbe-ceab5d7dc740": {
            field: "avgtotal",
            headerName: "AVG TOTAL",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.avgtotal),
        },
        "19ce7030-402c-495c-84ac-a29093bdb0ac": {
            field: "locationid",
            headerName: "LOCATION",
            headerAlign: "center",
            align: "center",
            width: 90,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "ab3e506e-bddb-456d-b967-922dcee74d56": {
            field: "location",
            headerName: "LOCATION",
            headerAlign: "center",
            align: "left",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 130,
            renderCell: (params) => params.row.stoneoldstatus === null ? params.value : (
                <Box
                    sx={{
                        "& .MuiBadge-badge": {
                            height: "0.75rem !important",
                            padding: "2px 4px !important",
                            fontSize: "8px",
                            top: "-1px",
                            right: "-20px",
                            backgroundColor: "#E5D9F2 !important",
                            color: "#624E88 !important",
                            fontWeight: "700"
                        },
                    }}
                >
                    <Badge
                        badgeContent={"TRANSIT"}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        {params.value}
                    </Badge>
                </Box>
            ),
        },
        "f97a0118-3891-4f77-abf7-8636c26d594c": {
            field: "country",
            headerName: "COUNTRY",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
            field: "quality",
            headerName: "QUALITY",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
            field: "shade",
            headerName: "SHADE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            width: 190,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
            field: "height",
            headerName: "HEIGHT",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
            field: "width",
            headerName: "WIDTH",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "8eaa8a03-d163-436d-8912-51ea06306f44": {
            field: "certificateid",
            headerName: "CERT",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "77e48fa7-d118-4ab8-865b-9b85b32a004f": {
            field: "fancycolour",
            headerName: "F.COLOR",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "ccba9873-174e-4060-963a-9893c3625bb2": {
            field: "fancycolorovertone",
            headerName: "OVERTONE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "c9aa6ee7-30e3-423e-a534-80bb5ef7bbaf": {
            field: "fancycolorintensity",
            headerName: "F.COL.INTENSITY",
            headerAlign: "center",
            align: "center",
            width: 140,
            renderCell: renderCellExpand,
        },
        "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
            field: "comment",
            headerName: "COMMENT",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "e7210f4a-6e0a-4591-8428-e6845004ed04": {
            field: "crownheight",
            headerName: "CR.HEIGHT",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "c4e65984-1682-4c1e-812b-8938e9078b2d": {
            field: "crownangle",
            headerName: "CR.ANG",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
            field: "culetsize",
            headerName: "CULET SZ",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "e3f77521-2c57-46bc-a02b-3c884685d2be": {
            field: "culetcondition",
            headerName: "CULET",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
            field: "depthpercent",
            headerName: "DEPTH%",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "e83c2978-9088-49f0-9dc1-bcced73025fd": {
            field: "gridlemin",
            headerName: "GIRDLEMIN",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
            field: "intensitylongtitle",
            headerName: "INTENSITYLONGTITLE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "06d2a589-0d42-4dde-8724-acf2448c839a": {
            field: "laserinscription",
            headerName: "INS",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "dd934505-1865-48cb-878f-f5d3c18af2d5": {
            field: "note",
            headerName: "NOTE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
            field: "paviliondepth",
            headerName: "PV.DEPTH",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
            field: "tablepercent",
            headerName: "TABLE%",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 75,
            renderCell: renderCellExpand,
        },
        "db078198-4416-4d53-b3d0-70d3a5418f65": {
            field: "open",
            headerName: "OPEN",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "e9028170-e978-4978-a2c9-1889c1821495": {
            field: "gridlecondition",
            headerName: "GIRDLE COND",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
            field: "gridlepercent",
            headerName: "GIRDLE%",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
            field: "pavilionangle",
            headerName: "PV.ANGLE",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
            field: "white",
            headerName: "WHITE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "24ba0bf8-4ca1-4726-ad90-19a62c8c72e6": {
            field: "boxid",
            headerName: "BOXID",
            headerAlign: "center",
            width: 80,
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            renderCell: renderCellExpand,
        },
        "6defca68-d5d9-4c30-ae83-938a01f45a07": {
            field: "colortype",
            headerName: "COL TYPE",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
        },
        "e32fe363-07cc-4307-82d2-82ae1069b5be": {
            field: "age",
            headerName: "AGE",
            headerAlign: "center",
            align: "center",
            valueGetter: (params) => {
                if (params.value)
                    return Utility.ConvertDateToAge(params.value);
                else
                    return null;
            },
            renderCell: (params) => {
                return params.value;
            },
        },
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                <CommonStoneSelection
                    title={"Enter multiple Stone Ids"}
                    handleSelection={handleSelection}
                    bgColor='#454545'
                    buttonDisabled={rows.length === 0} />

                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
                {showUploadedAvgSummary ? (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: "black",
                            fontWeight: 'normal',
                            fontSize: Constants.defaultTableFontSize,
                            marginRight: "45px"
                        }}
                    ><p style={{ margin: 0 }}>
                            <span>Total of New Avg Price </span> <b>{selectedNewTotalOfAvgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                            <span>Avg of New Avg Price: </span> <b>{selectedNewAvgOfAvgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                            <span>Avg of New Avg Discount: </span> <b>{selectedNewAvgOfAvgDiscount}</b></p>
                    </Box>
                ) : null}
                {stockLoader ? (
                    <CircularProgress sx={{ cursor: "pointer", height: "1.8rem !important", width: "1.8rem !important" }} />
                ) : (
                    <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                            onClick={() => {
                                setSelectionModel([]);
                                setShowUploadedAvgSummary(false);
                                handleSearch();
                            }}
                            color="primary"
                            fontSize="large"
                            sx={{ cursor: "pointer", height: "1.8rem", width: "1.8rem" }}
                        />
                    </Tooltip>
                )}
                <Tooltip title="Download Sample Revise Average Upload">
                    <a
                        href="/demo_excel/SampleReviseAverageUpload.csv"
                        download="SampleReviseAverageUpload.csv"
                        style={{ color: "red", marginRight: "10px", marginLeft: "7px" }}
                    >
                        <BackupTable size={25} />
                    </a>
                </Tooltip>
                <Tooltip title="Upload Revise Average">
                    <LoadingButton
                        color="info"
                        variant="outlined"
                        size="small"
                        sx={{ mr: "10px" }}
                        component="label"
                        type="submit"
                        loading={uploadLoader}
                        loadingPosition="start"
                        startIcon={<UploadFileIcon size="large" />}
                    >
                        Upload
                        <input
                            id="file-input"
                            hidden
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            multiple
                            type="file"
                            onChange={(e) => handleUpload(e.target.files[0])}
                            onClick={(e) => handleClear()}
                        />
                    </LoadingButton>
                </Tooltip>

                <Tooltip title="Apply Revised Avg">
                    <LoadingButton
                        color="success"
                        variant="contained"
                        size="small"
                        sx={{ ml: "5px" }}
                        onClick={() => handleApply()}
                        disabled={selectionModel.length === 0 || applyButtonDisabled}
                        type="Submit"
                        loading={applyLoader}
                        loadingPosition="start"
                        startIcon={<TaskAltIcon size="large" />}
                    >
                        Apply
                    </LoadingButton>
                </Tooltip>
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        )
    }

    return (
        <>
            {showStoneDetailModal ? (
                <StoneDetailModal
                    show={showStoneDetailModal}
                    stoneId={stoneId}
                    handleClose={handleClose}
                />
            ) : null}

            {showKapanDetailModal ? (
                <KapanHistoryModal
                    show={showKapanDetailModal}
                    kapanId={kapanId}
                    close={() => setShowKapanDetailModal(false)}
                />
            ) : null}
            {showPacketDetailModal ? (
                <PacketHistoryModal
                    show={showPacketDetailModal}
                    packetId={packetId}
                    kapanId={kapanId}
                    close={() => setShowPacketDetailModal(false)}
                />
            ) : null}
            {stockData ? (
                <TabMenuSnackbar
                    show={uploadSuccessSnackbar}
                    message={
                        stockData.length !== 0
                            ? `File loaded Successfully`
                            : `File could not be loaded`
                    }
                    variant={stockData.length !== 0 ? "success" : "error"}
                    autoHide={true}
                    title={stockData.length !== 0 ? "Success" : "Error"}
                    handleClose={handleClose}
                />
            ) : null}

            {ApplySuccessSnackbar && uploadResponse !== undefined && uploadResponse !== "" ? (
                <TabMenuSnackbar
                    show={ApplySuccessSnackbar}
                    message={
                        uploadResponse.status.toLowerCase() === "success"
                            ? `Revise Average Applied Successfully`
                            : `Revise Average Could Not Be Applied`
                    }
                    variant={uploadResponse.status.toLowerCase() === "success" ? "success" : "error"}
                    autoHide={true}
                    title={uploadResponse.status.toLowerCase() === "success" ? "Success" : "Error"}
                    handleClose={handleClose}
                />
            ) : null}

            {showSnackbar ? (
                <TabMenuSnackbar
                    show={showSnackbar}
                    message={snackBarMessage}
                    variant={"warning"}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={"Warning"}
                    handleClose={() => {
                        setShowSnackbar(false);
                    }}
                />
            ) : null}

            <TabMenuSnackbar
                show={showError}
                message={Constants.APiFailErrorMessage}
                variant={"error"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Failed"}
                handleClose={() => setShowError(false)}
            />
            <Box display={"flex"} margin={"4px 8px"} justifyContent='space-between' marginTop={"1px"}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        flexGrow: 1,
                        flexBasis: 0,
                        overflow: "hidden",
                        color: "black",
                        fontWeight: "normal",
                        px: 1,
                        textAlign: "center",
                        paddingTop: "10px",
                        paddingBottom: "21px",
                    }}
                >
                    <Stack
                        direction="row"
                        spacing={2}
                        useFlexGap
                        flexWrap="wrap"
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            justifyContent: "flex-start",
                        }}
                    >
                        <Typography
                            component="span"
                            sx={{ fontSize: Constants.defaultTableFontSize }}
                        >
                            No of Stones: <b>{noOfSelectedStones}</b>
                        </Typography>
                        <Typography
                            component="span"
                            sx={{ fontSize: Constants.defaultTableFontSize }}
                        >
                            Total Weight: <b>{selectedTotalSize}</b>
                        </Typography>
                        <Typography
                            component="span"
                            sx={{ fontSize: Constants.defaultTableFontSize }}
                        >
                            Total Price: <b>{selectedtotalPrice}</b>
                        </Typography>
                        <Typography
                            component="span"
                            sx={{ fontSize: Constants.defaultTableFontSize }}
                        >
                            Avg Price: <b>{selectedavgPrice}</b>
                        </Typography>
                        <Typography
                            component="span"
                            sx={{ fontSize: Constants.defaultTableFontSize }}
                        >
                            Avg Discount: <b>{selectedAvgDiscount}</b>
                        </Typography>
                        <Typography
                            component="span"
                            sx={{ fontSize: Constants.defaultTableFontSize }}
                        >
                            Total of Avg Price: <b>{selectedTotalOfAvgPrice}</b>
                        </Typography>
                        <Typography
                            component="span"
                            sx={{ fontSize: Constants.defaultTableFontSize }}
                        >
                            Avg of Avg Price: <b>{selectedAvgOfAvgPrice}</b>
                        </Typography>
                        <Typography
                            component="span"
                            sx={{ fontSize: Constants.defaultTableFontSize }}
                        >
                            Avg of Avg Discount:<b>{selectedAvgOfAvgDiscount}</b>
                        </Typography>
                    </Stack>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "15px",
                        alignItems: "center",
                        justifyContent: "flex-start"
                    }}
                >
                    {/* Color Palette Button */}
                    <Box>
                        <Box
                            id="demo-customized-button"
                            aria-controls={open ? 'demo-customized-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            variant="outlined"
                            disableElevation
                            onClick={handleClick}
                            endIcon={<KeyboardArrowDownIcon />}
                            sx={{
                                color: "#454545",
                                borderColor: "#454545",
                                borderRadius: "4px",
                                border: "1px solid black",
                                padding: "5px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "4rem",
                            }}
                        >
                            <img
                                src={colourchart}
                                alt="Color Scheme"
                                style={{
                                    height: "24px",
                                    width: "24px",
                                }}
                            />
                            <KeyboardArrowDownIcon />
                        </Box>

                        <StyledMenu
                            id="demo-customized-menu"
                            MenuListProps={{
                                'aria-labelledby': 'demo-customized-button',
                                style: {
                                    maxHeight: 250
                                },
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleCloseButton}
                        >
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#F9F08D", borderRadius: 20, margin: 10 }}></span>NEW
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#7EAEEE", borderRadius: 20, margin: 10 }}></span>LAB
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#FCCD91", borderRadius: 20, margin: 10 }}></span>RE-LAB
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#FFFFCC", borderRadius: 20, margin: 10 }}></span>RE-CHECK
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#B8ACF6", borderRadius: 20, margin: 10 }}></span>RE-CHECK_SENT
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#388BFF", borderRadius: 20, margin: 10 }}></span>RE-CHECK_DONE
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#E0E88C", borderRadius: 20, margin: 10 }}></span>MIX
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#FBDEDE", borderRadius: 20, margin: 10 }}></span>AVAILABLE_APPROVAL_PENDING
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#000000", borderRadius: 20, margin: 10 }}></span>AVAILABLE
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#B6B9D6", borderRadius: 20, margin: 10 }}></span>HOLD
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#CAF7F6", borderRadius: 20, margin: 10 }}></span>MEMO_OUT
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#CCFF99", borderRadius: 20, margin: 10 }}></span>SELL
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#F797D2", borderRadius: 20, margin: 10 }}></span>SELL_SENT
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#26D4B9", borderRadius: 20, margin: 10 }}></span>SOLD
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#F59598", borderRadius: 20, margin: 10 }}></span>SELL_CANCELLED
                            </MenuItem>
                            <MenuItem onClick={handleCloseButton} disableRipple>
                                <span style={{ height: "15px", width: "15px", backgroundColor: "#FEBD7D", borderRadius: 20, margin: 10 }}></span>AVAILABLE (IN_TRANSIT)
                            </MenuItem>
                        </StyledMenu>
                    </Box>
                </Box>
            </Box>
            {
                <Box>
                    <Box px={1}>
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .lavenderCell": {
                                    color: "#080808",
                                    backgroundColor: "#D8BFD8",
                                },
                                height: "71vh"
                            }}
                        >
                            <StyledDataGrid
                                disableRowSelectionOnClick={true}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "4px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },

                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                density="compact"
                                slots={{ toolbar: CustomToolbar }}
                                rows={rows}
                                loading={uploadLoader || stockLoader}
                                columns={columns}
                                processRowUpdate={processRowUpdate}
                                onProcessRowUpdateError={handleProcessRowUpdateError}
                                checkboxSelection={true}
                                onRowSelectionModelChange={(newSelectionModel) => {
                                    setSelectionModel(newSelectionModel);
                                }}
                                rowSelectionModel={selectionModel}
                                getRowId={(row) => row.stoneid}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            id: false,
                                            kapanid: false,
                                            packetid: false
                                        },
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                                apiRef={apiRef}
                                onCellClick={handleCellClick}
                                editMode="cell"
                            />
                        </Box>
                    </Box>
                </Box >
            }
        </>
    );
}
export default ReviseAverage;